var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStyleManage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.81 15.834a5.772 5.772 0 01-4.108-1.702A5.772 5.772 0 011 10.025c0-1.038.278-2.055.8-2.945a5.831 5.831 0 012.101-2.086.309.309 0 01.42.111.309.309 0 01-.112.42 5.216 5.216 0 00-2.594 4.5 5.203 5.203 0 005.197 5.196 5.204 5.204 0 005.196-5.196c0-1.798-.91-3.445-2.433-4.403a.307.307 0 11.327-.519c.816.514 1.5 1.23 1.972 2.068.489.866.747 1.852.747 2.854 0 1.55-.605 3.01-1.702 4.107a5.772 5.772 0 01-4.11 1.702z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.882 7.19a5.862 5.862 0 00-1.706-1.9l1.271-1.033a.6.6 0 00.117-.798l-1.5-2.199A.599.599 0 009.572 1H4.257c-.199 0-.383.098-.494.26l-1.5 2.199a.598.598 0 00.118.798l1.175.954A5.806 5.806 0 001 10.025a5.808 5.808 0 002.784 4.96.305.305 0 00.421-.103.307.307 0 00-.101-.42 5.164 5.164 0 01-2.491-4.44c0-1.788.932-3.461 2.443-4.407L6.54 7.633a.595.595 0 00.75 0l2.392-1.944a5.177 5.177 0 012.326 4.334 5.161 5.161 0 01-2.523 4.457.308.308 0 00.157.571.296.296 0 00.157-.044 5.846 5.846 0 002.045-2.08 5.82 5.82 0 00.777-2.904 5.834 5.834 0 00-.739-2.832zm-4.389-.51l2.242-4.816L11.05 3.79 7.493 6.68zM4.738 1.612h4.436L6.92 6.46 4.738 1.613zm1.614 5.08L2.779 3.79l1.367-2.001 2.206 4.904z"
  }))));
}

export default SvgStyleManage;